import React, { Component, Fragment } from 'react';
import { cart, modal, reservation, cursusModal } from 'actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Icon from 'common/components/Icon';
import Modal from "../modal/Modal";
import AddToCartComponent from "../cart/components/AddToCartComponent";
import langPrefix from 'common/helpers/langPrefix';

export const getCountProducts = function(dialog) {
  const types = Object.keys(dialog);
  let count = 0;

  types.forEach((type) => {
    count += Object.keys(dialog[type]).length;
  });

  return count;
};

class CartHeaderContainer extends Component {
  static propTypes = {
    modal: PropTypes.object.isRequired,
    actions: PropTypes.shape({
      cart: PropTypes.shape({
        fetch: PropTypes.func,
        onCloseCart: PropTypes.func,
        onDeleteSession: PropTypes.func,
        reservation: PropTypes.func,
        hideAlert: PropTypes.func,
        addCode: PropTypes.func,
        deleteCode: PropTypes.func,
      }),
      modal: PropTypes.shape({
        toggle: PropTypes.func,
        show: PropTypes.func,
        hide: PropTypes.func,
      }),
    }).isRequired,
    cart: PropTypes.shape({
      dialog: PropTypes.shape({
        sessions: PropTypes.object,
        openCartOnLoad: PropTypes.bool,
      }),
      addedToCartProduct: PropTypes.object.isRequired,
      showAddToCartModal: PropTypes.bool.isRequired,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      openClearMessage: false,
    };

    this.onCloseModalModal = this.onCloseModalModal.bind(this);
  }

  onCloseModalModal() {
    const {
      actions: {
        cart
      }
    } = this.props;
    cart.hideAddToCart();
  }

  render() {

    const {
      cart: {
        dialog,
        addedToCartProduct,
        showAddToCartModal,
      },
    } = this.props;

    return (
      <Fragment>
        <div className="header__cart-btn-wrapper">
          <a
            href={`/${langPrefix}cart`}
            className="header__cart-btn header__cart--not-empty cart-opener-processed"
            data-number={getCountProducts(dialog)}
          >
            <span className="svg-icon svg-icon--cart">
              <Icon name="cart" />
            </span>
          </a>
        </div>
        {showAddToCartModal && (
          <Modal
            closePortal={this.onCloseModalModal}
            position="right"
            withAnimation
          >
            <AddToCartComponent item={addedToCartProduct} />
          </Modal>
        )}
      </Fragment>
    );
  }
}

// export default CartContainer;
export default connect(
  state => ({
    cart: state.cart,
    modal: state.modal,
  }),
  dispatch => ({
    actions: {
      cart: bindActionCreators(cart, dispatch),
      modal: bindActionCreators(modal, dispatch),
      reservation: bindActionCreators(reservation, dispatch),
      cursusModal: bindActionCreators(cursusModal, dispatch),
    },
  }), null, {
    pure: false,
  },
)(CartHeaderContainer)
